<template>
        <b-modal v-if="agendamento" size="md" :id="'modal-cancelar-agendamento-' + agendamento.id" hide-footer centered title="Cancelar Agendamento">
		<h4 class="text-left">Você tem certeza que deseja cancelar esse agendamento?</h4>
		<div class="d-flex w-100 justify-content-between mt-5">
			<b-button @click.prevent="cancelarAgendamento" variant="success" :disabled="carregandoCancelarAgendamento">
			<span v-show="!carregandoCancelarAgendamento">
				SIM
			</span>
			<b-spinner v-show="carregandoCancelarAgendamento" variant="success" class="mx-auto"></b-spinner>
			</b-button>
		<b-button variant="danger" @click.prevent="$bvModal.hide('modal-cancelar-agendamento-' + agendamento.id)">NÃO</b-button>
		</div>
	</b-modal>
</template>

<script>
import AgendamentoService from "../../service/AgendamentoService.js";

export default{
	name: "ModalCancelarAgendamento",
	props: [ "agendamento" ],
	data() {
		return {
			carregandoCancelarAgendamento: false,
		};
	},
	created() {
	},
	methods: {
		cancelarAgendamento() {
			this.carregandoCancelarAgendamento = true;
			AgendamentoService.cancelar(this.agendamento.id)
				.then(() => {
					this.$bvModal.hide("modal-cancelar-agendamento-" + this.agendamento.id);
				})
				.then(() => {
					this.$emit("agendamentoCancelado");
				})
				.catch((err) => {
					if (err.response) {
				 		this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível cancelar o agendamento", "Erro", "danger");
					}
				})
				.finally(() => {
					this.carregandoCancelarAgendamento = false;
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autodDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/Agendamento/ModalCancelarAgendamento.vue